import React, { useRef } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { ConditionalWrapper } from 'components/ConditionalWrapper/ConditionalWrapper';
import { ReactComponent as WarningIcon } from 'components/icons/warning-icon.svg';
import { BpPlay } from 'models/tagging/BpPlay';
import { HitTypes } from '@trackman/baseball-shared-components';
import {
  FirstRow,
  NotSaved,
  PlaySequenceNumber,
  Speed,
  SpeedUnit,
  StyledBpPlay,
  TooltipText,
  Type,
  Warning,
} from './BpPlayComponentStyles';

export interface IProps {
  play: BpPlay;
  onClick: (play: BpPlay) => void;
  isSelected?: boolean;
  dataTest: string;
}
export const BpPlayComponent: React.FC<IProps> = observer((props: IProps) => {
  const { onClick, isSelected, play, dataTest } = props;
  const { playSequenceNumber } = play;
  const wrapperRef = useRef<any>();
  const playComponentClasses = classNames({
    selected: isSelected,
    even: playSequenceNumber && playSequenceNumber % 2 === 0,
    odd: playSequenceNumber && playSequenceNumber % 2 !== 0,
    animate: play.shouldAnimate,
  });

  return play.isWarmup === false ? (
    <ConditionalWrapper
      condition={!play.isTagStored && !isSelected}
      wrapper={(children: React.ReactElement) => <NotSaved>{children}</NotSaved>}
    >
      <StyledBpPlay ref={wrapperRef} className={`${playComponentClasses}`} onClick={() => onClick(play)} data-test={dataTest}>
        <FirstRow>
          <Speed>{play.exitSpeed ? `${play.exitSpeed}` : 'No hit'}</Speed>
          {play.exitSpeed && <SpeedUnit>MPH</SpeedUnit>}
          {play.isChanged && !isSelected && (
            <Warning>
              <WarningIcon />
              <TooltipText>Play not saved</TooltipText>
            </Warning>
          )}
          <PlaySequenceNumber>{play.playSequenceNumber}</PlaySequenceNumber>
        </FirstRow>

        <Type>{play.hitType === HitTypes.Undefined ? '-' : play.hitType}</Type>
      </StyledBpPlay>
    </ConditionalWrapper>
  ) : null;
});
